var render = function render(){var _vm=this,_c=_vm._self._c;return _c('service-screen-layout',{attrs:{"parts":_vm.parts},scopedSlots:_vm._u([{key:"cross-connect",fn:function(){return [_c('CrossConnectDetails',{attrs:{"crossconnect":_vm.saleDefinition.definition.crossconnect},on:{"saveSale":_vm.saveSale}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }